export function insertItem<T>(items: T[], item: T, index: number) {
  return [...items.slice(0, index), item, ...items.slice(index)];
}

export function removeItem<T>(items: T[], index: number) {
  return [...items.slice(0, index), ...items.slice(index + 1)];
}

export function updateItem<T>(items: T[], item: T, index: number) {
  return items.map((currentItem, currentIndex) => {
    if (currentIndex !== index) {
      return currentItem;
    }

    return item;
  });
}
